import React, {useEffect, useRef, useState} from 'react';
import {InputAdornment, TextField} from "@mui/material";
import CalculateIcon from '@mui/icons-material/Calculate';
import {isAllowedNonNegativeDecimalInput, normalizeNumericInputValue} from "../../../../../../utils/common/isAllowedDecimalInput";

const ArrivalMaterialTextField = ({
                                      label,
                                      values,
                                      setValues,
                                      field,
                                      disabled,
                                      type = "text",
                                      nonNegative = false,
                                      validationError,
                                      setValidationState,
                                      setCalculatorOpen,
                                      setPosition
                                  }) => {
    const ref = useRef(null)

    useEffect(() => {
        if (ref.current && setPosition) {
            setPosition(ref.current.getBoundingClientRect());
        }
    }, []);

    return (
        <div>
            <TextField
                ref={ref}
                size={"small"}
                sx={{
                    width: '100%',
                    minWidth: {xs: '300px', sm: '360px', md: '400px'},
                    gap: 0,
                }}
                autoComplete={"off"}
                margin="normal"
                key={field}
                label={label}
                name={field}
                type={type}
                error={!!validationError}
                helperText={validationError}
                disabled={disabled == null ? false : disabled}
                value={values === null ? "" : values[field]}
                onChange={(e) => {
                    const currentValue = values === null ? "" : values[field];
                    let inputValue = e.target.value;
                    if (nonNegative && !isAllowedNonNegativeDecimalInput(inputValue)) {
                        return;
                    }
                    if (nonNegative) {
                        inputValue = normalizeNumericInputValue(currentValue, inputValue, false);
                    }
                    setValues({...values, [e.target.name]: inputValue})
                    validationError && setValidationState("")
                }
                }
                InputProps={{
                    endAdornment: setCalculatorOpen &&
                        <InputAdornment
                            onClick={() => !disabled && setCalculatorOpen(field)} position="end"
                            sx={{
                                opacity: disabled ? 0.5 : 1,
                                "p": {
                                    cursor: disabled ? "auto" : "pointer",
                                    lineHeight: 1
                                }
                            }}><CalculateIcon/></InputAdornment>,
                }}
            />
        </div>
    );
};

export default ArrivalMaterialTextField;